var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"imputation-grid-recap"},[_c('div',{staticClass:"label color-green-blue"},[_vm._v("Total")]),_vm._l((_vm.sums),function(sum,i){return _c('div',{key:i,class:_vm.getClass(_vm.error[i], _vm.cellsToDisplay[i], _vm.numberToDisplay[i])},[_vm._v(" "+_vm._s(sum)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }